import { browserHistory } from 'react-router';
import Promise from 'bluebird';
import tree from '../state';
import * as productService from '../services/productService';

export const enterProductAction = ({ params }, replace, callback) => {
	tree.set('loading', true);
	productService.getProduct(params.sku).then(product => {

		tree.set('product', product);
		tree.set('loading', false);
		callback();
	}).catch(err => {
		if (err.status === 404) {
			tree.set('product', null);
			tree.set('loading', false);
			callback(); // eslint-disable-line callback-return
		}
		callback(err);
	});
};

export const getProductAction = sku => {
	tree.set('loading', true);
	return productService.getProduct(sku).then(product => {

		tree.set('product', product);
		tree.set('loading', false);
	}).catch(err => {
		if (err.status === 404) {
			tree.set('product', null);
			tree.set('loading', false);
			return Promise.reject(err);
		}
		return Promise.reject(err);
	});
};

// The Security Safe product will have accessories info from the product X125ML
export const getSecuritySafetyAction = () => {
	tree.set('loading', true);
	return productService.getProduct("X125ML").then(product => {
		tree.set('product', product);
		tree.set('loading', false);
	}).catch(err => {
		if (err.status === 404) {
			tree.set('product', null);
			tree.set('loading', false);
			return Promise.reject(err);
		}
		return Promise.reject(err);
	});
};

export const enterProductSearch = ({ params, location }, replace, callback) => {
	// console.log("enterProductSearch");
	tree.set('loading', true);
	const data = Object.assign({}, location.query, params);
	let searchUrl = '/products';
	if (params.category) {
		data.category = params.category;
		searchUrl += '/' + data.category;
	}

	productService.productSearch(data).then(result => {
		tree.set('productSearchResults', result);
		tree.set('searchUrl', searchUrl);
		tree.set('loading', false);
		callback();
	});
};

export const enterProductSelector = ({ params, location }, replace, callback) => {
	// console.log("enterProductSelector");
	tree.set('loading', true);
	const data = Object.assign({}, location.query, params);
	data.minFacetCount = 0;
	productService.productSearch(data).then(result => {
		tree.set('productSearchResults', result);
		tree.set('loading', false);
		callback();
	});
};

export const enterProductCompare = ({ params }, replace, callback) => {
	tree.set('loading', true);
	const skus = params;
	productService.getProductsToCompare(skus).then(products => {
		tree.set('productsToCompare', products);
		tree.set('loading', false);
		callback();
	});
};

export const productSearchUpdate = (category, query) => {
	// console.log("productSearchUpdate");
	tree.set('searchLoading', true);
	const data = Object.assign({}, query);
	if (category) {
		data.category = category;
	}
	productService.productSearch(data).then(result => {
		tree.set('productSearchResults', result);
		tree.set('searchLoading', false);
	});
};

export const clickSearchFacet = (facet, value, checked) => {
	const location = Object.assign({}, browserHistory.getCurrentLocation());
	location.action = 'PUSH';
	if (checked) {
		let valueArray = [];
		if ('sort' === facet) {
			value = checked;
			// console.log("facet: " + facet);
			// console.log("value: ");
			// console.dir(value);
			// console.log("checked: " + checked);
			if (location.query[facet] !== null) {
				const query = location.query[facet];
				if (query) {
					if (Array.isArray(query)) {
						query.splice(query.indexOf(value), 1);
						location.query[facet] = query;
					} else {
						delete location.query[facet];
					}
				}
			}
		}
		if ('priceSort' === facet) {
			if (location.query[facet] !== null) {
				const query = location.query[facet];
				if (query) {
					if (Array.isArray(query)) {
						query.splice(query.indexOf(value), 1);
						location.query[facet] = query;
					} else {
						delete location.query[facet];
					}
				}
			}
		}

		if (facet in location.query) {
			const existing = location.query[facet];
			if (Array.isArray(existing)) {
				valueArray = existing;
			} else {
				valueArray.push(existing);
			}
		}
		valueArray.push(value);
		const facetObject = {};
		facetObject[facet] = valueArray;
		Object.assign(location.query, facetObject);
	} else {
		const query = location.query[facet];
		if (query) {
			if (Array.isArray(query)) {
				query.splice(query.indexOf(value), 1);
				location.query[facet] = query;
			} else {
				delete location.query[facet];
			}
		}
	}

	browserHistory.push(location);
	tree.set('searchUrl', browserHistory.getCurrentLocation());
};


// WEBPACK FOOTER //
// ./src/actions/productActions.js